import { render } from "./CasoDeUso.vue?vue&type=template&id=4cefad13&scoped=true"
import script from "./CasoDeUso.vue?vue&type=script&lang=js"
export * from "./CasoDeUso.vue?vue&type=script&lang=js"

import "./CasoDeUso.vue?vue&type=style&index=0&id=4cefad13&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cefad13"]])

export default __exports__